<template>
    <b-col v-if="filterGrid" style="padding-left: 0px; padding-right: 0px" :sm="sm" :md="md" :lg="lg">
        <label :for="disabled ? null : id" class="styled-checkbox" :class="{ 'styled-checkbox--no-text': noText }">
            <span v-if="html" class="button" v-html="html || label" />
            <input
                :id="id"
                type="checkbox"
                :checked="value"
                :disabled="disabled"
                :required="required"
                @input="handleInput"
            />
            <span v-if="disabled" class="disabled__checkbox"> </span>
            <span v-else class="checkmark">
                <CheckMarkHeavy v-if="value" />
            </span>
        </label>
    </b-col>
    <label
        v-else
        :class="[
            { 'styled-checkbox': !variant || variant === 'default' },
            { 'styled-checkbox--chip': variant === 'chip' },
            { 'styled-checkbox--no-text': noText },
            { checked: value },
        ]"
        :for="disabled ? null : id"
    >
        <span v-if="variant === 'chip'" class="checkmark" style="width: 16px; height: 16px">
            <CheckIcon v-if="variant === 'chip'" />
        </span>
        <CircleIcon v-if="variant === 'chip'" class="circle" />
        <span v-if="!noText" class="button" v-html="html || label" />
        <input
            :id="id"
            type="checkbox"
            :checked="value"
            :disabled="disabled"
            :required="required"
            @input="handleInput"
        />
        <span v-if="(!variant || variant === 'default') && !disabled" class="checkmark">
            <CheckMarkHeavy v-if="value" />
        </span>
        <span v-if="disabled" class="disabled__checkbox"> </span>
    </label>
</template>

<script>
import Check3 from './Icon/Check3.vue';
import CheckMarkHeavy from './Icon/CheckMarkHeavy.vue';
import CircleIcon from './Icon/CircleIcon.vue';

export default {
    name: 'StyledCheckbox',
    components: {
        CheckIcon: Check3,
        CircleIcon,
        CheckMarkHeavy,
    },

    props: {
        id: {
            type: [String, Number],
            required: true,
        },
        html: {
            type: String,
            required: false,
            default: '',
        },
        label: {
            type: String,
            required: false,
            default: '',
        },
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        value: {
            type: Boolean,
            required: false,
            default: false,
        },
        variant: {
            type: String,
            required: false,
            default: 'default',
        },
        sm: {
            type: String,
            required: false,
            default: '12',
        },
        md: {
            type: String,
            required: false,
            default: '6',
        },
        lg: {
            type: String,
            required: false,
            default: '4',
        },
        filterGrid: {
            type: Boolean,
            require: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
        },
    },
    computed: {
        noText() {
            return !this.html && !this.label;
        },
    },

    methods: {
        handleInput(e) {
            this.$emit('input', e.target.checked, this.id);
        },
    },
};
</script>

<style scoped>
.styled-checkbox {
    padding: 12px 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 0;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.styled-checkbox--chip {
    background-color: var(--color-white);
    color: #1c84b2;
    border: 1px solid #1c84b2;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px 0 8px;
    height: 32px;
    margin-bottom: 0;
    border-radius: 40px;
    position: relative;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.styled-checkbox--chip .checkmark {
    margin-right: 8px !important;
    display: none !important;
    background-color: #1c84b2 !important;
}
.styled-checkbox--chip .circle {
    margin-right: 8pxt;
}
.styled-checkbox--chip.checked {
    color: var(--color-white) !important;
    background-color: #1c84b2 !important;
}
.styled-checkbox--chip.checked .checkmark {
    display: inline-flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
}
.styled-checkbox--chip.checked .circle {
    display: none !important;
}
.button {
    margin-left: 12px;
}
.styled-checkbox--chip .button {
    font-size: 14px;
    font-weight: 500;
}

.styled-checkbox--chip:hover {
    cursor: pointer;
}

.styled-checkbox input,
.styled-checkbox--chip input {
    display: none;
}

.styled-checkbox .checkmark {
    background-color: var(--color-white);
    border: 1px solid #6d7175;
    border-radius: 2px;
    position: absolute;
    left: 0px;
    height: 16px;
    width: 16px;
}

.styled-checkbox .disabled__checkbox {
    align-items: center;
    background: #eef1f1;
    border: 1px solid #6d7175;
    border-radius: 2px;
    position: absolute;
    left: 0px;
    top: 0px;
    height: 16px;
    width: 16px;
    cursor: not-allowed;
}

.styled-checkbox:hover .checkmark {
    border-color: #3c3c3c !important;
}

.styled-checkbox input:checked ~ .checkmark {
    background-color: var(--color-yellow);
    border-color: var(--color-yellow);
    display: flex;
    justify-content: center;
    align-items: center;
}

.styled-checkbox--no-text {
    padding: 0 8px 0 16px;
}

.styled-checkbox--no-text .checkmark {
    left: 0;
    top: 0;
}
</style>
